if (!customElements.get('lakras-mobile-menu')) {
  class LakrasMobileMenu extends HTMLElement {
    connectedCallback() {
      if (this.onMenuClick) return;
      this.drawer = this.closest('header-drawer');
      this.drawerDetails = this.drawer?.querySelector('details');
      this.toggle = this.querySelector('[data-menu-highlights]');
      this.links = this.querySelector('[data-menu-highlight-links]');
      if (!this.drawerDetails || !this.toggle || !this.links) return;
      this.onMenuClick = (event) => {
        const action = event.target.closest('[data-menu-back], [data-menu-highlights]');
        if (!action || !this.contains(action)) return;
        event.preventDefault();
        event.stopPropagation();
        if (action.hasAttribute('data-menu-back')) {
          const opener = this.drawerDetails.querySelector('summary');
          if (typeof this.drawer.closeMenuDrawer === 'function') {
            this.drawer.closeMenuDrawer(event, opener);
            opener.setAttribute('aria-expanded', 'false');
          }
        } else {
          this.setHighlights(this.toggle.getAttribute('aria-expanded') !== 'true');
        }
      };
      this.addEventListener('click', this.onMenuClick, true);
      this.observer = new MutationObserver(() => {
        if (this.drawerDetails.open) this.setHighlights(true);
      });
      this.observer.observe(this.drawerDetails, { attributes: true, attributeFilter: ['open'] });
      this.setHighlights(true);
    }

    setHighlights(expanded) {
      this.toggle.setAttribute('aria-expanded', String(expanded));
      this.links.hidden = !expanded;
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      if (this.onMenuClick) this.removeEventListener('click', this.onMenuClick, true);
      this.onMenuClick = null;
    }
  }
  customElements.define('lakras-mobile-menu', LakrasMobileMenu);
}
